"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HilOperatingConditionBoundarySchema = exports.OPERATING_CONDITION_BOUNDARY_DESCRIPTION = void 0;
exports.extendOperatingConditionSchemaWithSignalIds = extendOperatingConditionSchemaWithSignalIds;
const z = require("zod");
const BoundaryCharacteristic_1 = require("../BoundaryCharacteristic");
const HilAbsoluteMaximumRatingBoundary_1 = require("./HilAbsoluteMaximumRatingBoundary");
exports.OPERATING_CONDITION_BOUNDARY_DESCRIPTION = 'Defines the operating conditions or electrical characteristics for a signal. These conditions describe the correct operating mode of the device where it is intended to be used.';
exports.HilOperatingConditionBoundarySchema = HilAbsoluteMaximumRatingBoundary_1.HilAbsoluteMaximumRatingBoundarySchema.extend({
    nominal: z
        .string()
        .nullable()
        .describe('The nominal value of the characteristic in the appropriate SI units for the characteristic.'),
    nominalRelativeToSignalId: z
        .union([z.string(), z.number()])
        .nullable()
        .describe('The signal that the nominal value is relative to, if the characteristic requires a relative signal. Characteristics like Voltage and Power require a relative signal, while others like Current and Temperature do not.'),
}).describe(exports.OPERATING_CONDITION_BOUNDARY_DESCRIPTION);
function extendOperatingConditionSchemaWithSignalIds(signalIds, allowedCharacteristics) {
    const ratedSchema = exports.HilOperatingConditionBoundarySchema.extend({
        characteristic: allowedCharacteristics ? z.enum(allowedCharacteristics) : BoundaryCharacteristic_1.BoundaryCharacteristicSchema,
    }).describe(exports.OPERATING_CONDITION_BOUNDARY_DESCRIPTION);
    if (signalIds.length < 1) {
        return ratedSchema;
    }
    const useSignalIds = ['', ...signalIds.map((id) => id.toString())];
    return ratedSchema
        .extend({
        signalId: z.enum(useSignalIds).describe(exports.HilOperatingConditionBoundarySchema.shape.signalId.description),
        minimumRelativeToSignalId: z
            .enum(useSignalIds)
            .nullable()
            .describe(exports.HilOperatingConditionBoundarySchema.shape.minimumRelativeToSignalId.description),
        nominalRelativeToSignalId: z
            .enum(useSignalIds)
            .nullable()
            .describe(exports.HilOperatingConditionBoundarySchema.shape.nominalRelativeToSignalId.description),
        maximumRelativeToSignalId: z
            .enum(useSignalIds)
            .nullable()
            .describe(exports.HilOperatingConditionBoundarySchema.shape.maximumRelativeToSignalId.description),
    })
        .describe(exports.OPERATING_CONDITION_BOUNDARY_DESCRIPTION);
}
//# sourceMappingURL=HilOperatingConditionBoundary.js.map